import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class UserRegisterSessionStorageService {
   private readonly userOrderingOptionsStorageKey = '__ndt-user-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeUserOrderingOptions(): void {
      localStorage.removeItem(this.userOrderingOptionsStorageKey);
   }

   getUserOrderingOptions() {
      const localData = localStorage.getItem(this.userOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setUserOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.userOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
